import { AddressBookPayload } from './models/address-book.model';

/** API rejects postal codes with spaces; order forms often allow them. */
export function normalizeAddressBookPostalCode(postalCode: string | null | undefined): string | null {
    const value = (postalCode ?? '').trim();
    if (!value) return null;
    return value.replace(/\s+/g, '');
}

export function normalizeAddressBookPayload<T extends Partial<AddressBookPayload>>(payload: T): T {
    return {
        ...payload,
        postal_code: normalizeAddressBookPostalCode(payload.postal_code)
    };
}

export function getAddressBookApiErrorMessage(error: any, fallback = 'Failed to save address'): string {
    const body = error?.error;
    const nested = body?.data?.errors ?? body?.errors;

    if (Array.isArray(nested)) {
        const messages = nested
            .map((e: any) => (typeof e === 'string' ? e : e?.msg || e?.message || e?.detail))
            .filter(Boolean);
        if (messages.length) return messages.join(', ');
    }

    if (nested && typeof nested === 'object') {
        const messages = Object.values(nested).flat().filter(Boolean);
        if (messages.length) return messages.join(', ');
    }

    return body?.message || error?.message || fallback;
}
